/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_License_TermsInputs */

const en_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License Terms`)
};

const es_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de la licencia`)
};

const fr_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions de licence`)
};

const de_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenzbedingungen`)
};

const ja_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライセンス条件`)
};

const zh_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许可条款`)
};

const ar_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شروط الترخيص`)
};

const id_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syarat Lisensi`)
};

const it_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di Licenza`)
};

const ru_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия лицензии`)
};

const pt_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Licença`)
};

const ko_field_license_terms = /** @type {(inputs: Field_License_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이선스 조건`)
};

/**
* | output |
* | --- |
* | "License Terms" |
*
* @param {Field_License_TermsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_license_terms = /** @type {((inputs?: Field_License_TermsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_License_TermsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_license_terms(inputs)
	if (locale === "es") return es_field_license_terms(inputs)
	if (locale === "fr") return fr_field_license_terms(inputs)
	if (locale === "de") return de_field_license_terms(inputs)
	if (locale === "ja") return ja_field_license_terms(inputs)
	if (locale === "zh") return zh_field_license_terms(inputs)
	if (locale === "ar") return ar_field_license_terms(inputs)
	if (locale === "id") return id_field_license_terms(inputs)
	if (locale === "it") return it_field_license_terms(inputs)
	if (locale === "ru") return ru_field_license_terms(inputs)
	if (locale === "pt") return pt_field_license_terms(inputs)
	return ko_field_license_terms(inputs)
});